import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollStore } from "../lib/scroll";
import { Hero } from "../components/sora/Hero";
import { Intro } from "../components/sora/Intro";
import { Services } from "../components/sora/Services";
import { Portfolio } from "../components/sora/Portfolio";
import { About } from "../components/sora/About";
import { Approach } from "../components/sora/Approach";
import { FullBleed } from "../components/sora/FullBleed";
import { Contact } from "../components/sora/Contact";

export default function Home({ start }) {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const t = setTimeout(
        () => scrollStore.scrollTo(location.state.scrollTo),
        700
      );
      return () => clearTimeout(t);
    }
  }, [location.state]);

  return (
    <main>
      {start && (
        <Hero onExplore={() => scrollStore.scrollTo("#intro")} />
      )}
      <Intro />
      <Services />
      <Portfolio />
      <About />
      <Approach />
      <FullBleed />
      <Contact />
    </main>
  );
}
